import { FC } from 'react';

import { Figure } from './types';

interface FigureRendererProps {
  figure: Pick<Figure, 'type' | 'color' | 'size'>;
  className?: string;
}

export const FigureRenderer: FC<FigureRendererProps> = ({ figure, className = 'w-full h-full' }) => {
  if (figure.type === 'family-elder') {
    return (
      <svg viewBox="0 0 40 90" className={className}>
        <circle cx="20" cy="15" r="10" fill={figure.color} />
        <ellipse cx="20" cy="50" rx="12" ry="30" fill={figure.color} />
        <circle cx="16" cy="14" r="3" fill="none" stroke="white" strokeWidth="1.5" />
        <circle cx="24" cy="14" r="3" fill="none" stroke="white" strokeWidth="1.5" />
        <line x1="19" y1="14" x2="21" y2="14" stroke="white" strokeWidth="1.5" />
      </svg>
    );
  }
  if (figure.type === 'family-adult') {
    return (
      <svg viewBox="0 0 40 80" className={className}>
        <circle cx="20" cy="15" r="9" fill={figure.color} />
        <ellipse cx="20" cy="48" rx="11" ry="27" fill={figure.color} />
        <circle cx="17" cy="14" r="1.5" fill="white" />
        <circle cx="23" cy="14" r="1.5" fill="white" />
        <path d="M 12 10 Q 12 6 20 6 Q 28 6 28 10" fill={figure.color} stroke={figure.color} strokeWidth="2" />
      </svg>
    );
  }
  if (figure.type === 'family-teen') {
    return (
      <svg viewBox="0 0 40 75" className={className}>
        <circle cx="20" cy="14" r="8" fill={figure.color} />
        <ellipse cx="20" cy="45" rx="10" ry="24" fill={figure.color} />
        <circle cx="17" cy="13" r="1.5" fill="white" />
        <circle cx="23" cy="13" r="1.5" fill="white" />
      </svg>
    );
  }
  if (figure.type === 'family-child') {
    return (
      <svg viewBox="0 0 35 60" className={className}>
        <circle cx="17.5" cy="12" r="7" fill={figure.color} />
        <ellipse cx="17.5" cy="35" rx="8" ry="18" fill={figure.color} />
        <circle cx="15" cy="11" r="1.5" fill="white" />
        <circle cx="20" cy="11" r="1.5" fill="white" />
        <circle cx="12" cy="14" r="2" fill="#FF6B9D" opacity="0.4" />
        <circle cx="23" cy="14" r="2" fill="#FF6B9D" opacity="0.4" />
      </svg>
    );
  }
  if (figure.type === 'family-baby') {
    return (
      <svg viewBox="0 0 30 50" className={className}>
        <circle cx="15" cy="12" r="6" fill={figure.color} />
        <ellipse cx="15" cy="30" rx="7" ry="14" fill={figure.color} />
        <circle cx="13" cy="11" r="1" fill="white" />
        <circle cx="17" cy="11" r="1" fill="white" />
        <line x1="8" y1="22" x2="22" y2="22" stroke="white" strokeWidth="1.5" opacity="0.6" />
        <line x1="8" y1="28" x2="22" y2="28" stroke="white" strokeWidth="1.5" opacity="0.6" />
        <line x1="8" y1="34" x2="22" y2="34" stroke="white" strokeWidth="1.5" opacity="0.6" />
      </svg>
    );
  }
  if (figure.type === 'emotional-calm') {
    return (
      <svg viewBox="0 0 40 80" className={className}>
        <circle cx="20" cy="15" r="9" fill={figure.color} />
        <ellipse cx="20" cy="48" rx="11" ry="27" fill={figure.color} />
        <path d="M 12 8 Q 10 15 12 25" stroke={figure.color} strokeWidth="2" fill="none" />
        <path d="M 14 8 Q 12 15 14 28" stroke={figure.color} strokeWidth="2" fill="none" />
        <path d="M 26 8 Q 28 15 26 28" stroke={figure.color} strokeWidth="2" fill="none" />
        <path d="M 28 8 Q 30 15 28 25" stroke={figure.color} strokeWidth="2" fill="none" />
        <circle cx="17" cy="14" r="1.5" fill="white" />
        <circle cx="23" cy="14" r="1.5" fill="white" />
        <line x1="16" y1="19" x2="24" y2="19" stroke="white" strokeWidth="1.5" strokeLinecap="round" />
      </svg>
    );
  }
  if (figure.type === 'emotional-upset') {
    return (
      <svg viewBox="0 0 50 90" className={className}>
        <ellipse cx="25" cy="20" rx="12" ry="13" fill={figure.color} />
        <ellipse cx="25" cy="55" rx="13" ry="28" fill={figure.color} />
        <rect x="5" y="35" width="8" height="30" rx="4" fill={figure.color} transform="rotate(-30 9 35)" />
        <rect x="37" y="35" width="8" height="30" rx="4" fill={figure.color} transform="rotate(30 41 35)" />
        <line x1="20" y1="15" x2="22" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <line x1="28" y1="15" x2="30" y2="17" stroke="white" strokeWidth="2" strokeLinecap="round" />
        <ellipse cx="25" cy="25" rx="3" ry="5" fill="white" />
      </svg>
    );
  }
  if (figure.type === 'emotional-happy') {
    return (
      <svg viewBox="0 0 40 80" className={className}>
        <circle cx="20" cy="15" r="9" fill={figure.color} />
        <ellipse cx="20" cy="48" rx="11" ry="27" fill={figure.color} />
        <circle cx="17" cy="14" r="2" fill="white" />
        <circle cx="23" cy="14" r="2" fill="white" />
        <path d="M 14 18 Q 20 22 26 18" stroke="white" strokeWidth="2" fill="none" strokeLinecap="round" />
        <circle cx="12" cy="16" r="2.5" fill="#FF6B9D" opacity="0.4" />
        <circle cx="28" cy="16" r="2.5" fill="#FF6B9D" opacity="0.4" />
      </svg>
    );
  }
  if (figure.type === 'house') {
    return (
      <svg viewBox="0 0 60 60" className={className}>
        <path d="M 5 30 L 30 10 L 55 30 Z" fill={figure.color} stroke="#8B7355" strokeWidth="1.5" />
        <rect x="10" y="30" width="40" height="25" fill={figure.color} stroke="#8B7355" strokeWidth="1.5" />
        <rect x="16" y="35" width="8" height="8" fill="#A9C5D8" stroke="#6B8E9B" strokeWidth="1" />
        <rect x="36" y="35" width="8" height="8" fill="#A9C5D8" stroke="#6B8E9B" strokeWidth="1" />
        <rect x="26" y="40" width="8" height="15" fill="#8B7355" stroke="#6B5535" strokeWidth="1" />
      </svg>
    );
  }
  if (figure.type === 'tree') {
    return (
      <svg viewBox="0 0 50 70" className={className}>
        <rect x="20" y="35" width="10" height="35" rx="2" fill="#8B7355" />
        <circle cx="25" cy="25" r="18" fill={figure.color} />
        <path d="M 15 20 Q 12 18 14 15" stroke="#6B8E23" strokeWidth="1" fill="none" opacity="0.6" />
        <path d="M 20 18 Q 18 15 20 12" stroke="#6B8E23" strokeWidth="1" fill="none" opacity="0.6" />
        <path d="M 30 18 Q 32 15 30 12" stroke="#6B8E23" strokeWidth="1" fill="none" opacity="0.6" />
        <path d="M 35 20 Q 38 18 36 15" stroke="#6B8E23" strokeWidth="1" fill="none" opacity="0.6" />
      </svg>
    );
  }
  if (figure.type === 'animal-dog') {
    return (
      <svg viewBox="0 0 60 40" className={className}>
        <ellipse cx="35" cy="25" rx="18" ry="10" fill={figure.color} />
        <circle cx="15" cy="20" r="10" fill={figure.color} />
        <ellipse cx="10" cy="15" rx="4" ry="7" fill={figure.color} />
        <ellipse cx="20" cy="15" rx="4" ry="7" fill={figure.color} />
        <rect x="22" y="30" width="4" height="8" rx="2" fill={figure.color} />
        <rect x="30" y="30" width="4" height="8" rx="2" fill={figure.color} />
        <rect x="40" y="30" width="4" height="8" rx="2" fill={figure.color} />
        <rect x="48" y="30" width="4" height="8" rx="2" fill={figure.color} />
        <path d="M 53 22 Q 58 18 56 12" stroke={figure.color} strokeWidth="3" fill="none" strokeLinecap="round" />
        <circle cx="13" cy="18" r="1.5" fill="white" />
        <circle cx="17" cy="18" r="1.5" fill="white" />
      </svg>
    );
  }
  if (figure.type === 'animal-cat') {
    return (
      <svg viewBox="0 0 50 45" className={className}>
        <ellipse cx="25" cy="30" rx="12" ry="10" fill={figure.color} />
        <circle cx="25" cy="15" r="8" fill={figure.color} />
        <path d="M 18 10 L 15 4 L 22 12" fill={figure.color} />
        <path d="M 32 10 L 35 4 L 28 12" fill={figure.color} />
        <path d="M 35 28 Q 45 25 42 15" stroke={figure.color} strokeWidth="3.5" fill="none" strokeLinecap="round" />
        <circle cx="22" cy="14" r="1.5" fill="white" />
        <circle cx="28" cy="14" r="1.5" fill="white" />
        <line x1="15" y1="17" x2="10" y2="16" stroke="white" strokeWidth="0.8" />
        <line x1="15" y1="18" x2="10" y2="19" stroke="white" strokeWidth="0.8" />
        <line x1="35" y1="17" x2="40" y2="16" stroke="white" strokeWidth="0.8" />
        <line x1="35" y1="18" x2="40" y2="19" stroke="white" strokeWidth="0.8" />
      </svg>
    );
  }
  if (figure.type === 'animal-bird') {
    return (
      <svg viewBox="0 0 50 40" className={className}>
        <ellipse cx="25" cy="22" rx="10" ry="8" fill={figure.color} />
        <circle cx="18" cy="14" r="5" fill={figure.color} />
        <path d="M 13 14 L 8 13 L 13 16 Z" fill="#FFA500" />
        <ellipse cx="30" cy="20" rx="12" ry="5" fill={figure.color} opacity="0.7" transform="rotate(-20 30 20)" />
        <path d="M 33 24 L 40 28 L 38 22 L 42 26" stroke={figure.color} strokeWidth="2" fill="none" />
        <circle cx="18" cy="13" r="1" fill="white" />
        <line x1="23" y1="28" x2="23" y2="34" stroke={figure.color} strokeWidth="1.5" />
        <line x1="27" y1="28" x2="27" y2="34" stroke={figure.color} strokeWidth="1.5" />
      </svg>
    );
  }
  if (figure.type === 'cocoon') {
    return (
      <svg viewBox="0 0 35 55" className={className}>
        <circle cx="17.5" cy="12" r="7" fill="#FFDAB9" />
        <ellipse cx="17.5" cy="35" rx="10" ry="18" fill={figure.color} />
        <line x1="7.5" y1="25" x2="27.5" y2="25" stroke="white" strokeWidth="1.5" opacity="0.5" />
        <line x1="7.5" y1="30" x2="27.5" y2="30" stroke="white" strokeWidth="1.5" opacity="0.5" />
        <line x1="7.5" y1="35" x2="27.5" y2="35" stroke="white" strokeWidth="1.5" opacity="0.5" />
        <line x1="7.5" y1="40" x2="27.5" y2="40" stroke="white" strokeWidth="1.5" opacity="0.5" />
        <line x1="7.5" y1="45" x2="27.5" y2="45" stroke="white" strokeWidth="1.5" opacity="0.5" />
        <line x1="14" y1="11" x2="16" y2="11" stroke="black" strokeWidth="1" strokeLinecap="round" />
        <line x1="19" y1="11" x2="21" y2="11" stroke="black" strokeWidth="1" strokeLinecap="round" />
      </svg>
    );
  }
  if (figure.type === 'striped') {
    return (
      <svg viewBox="0 0 40 80" className={className}>
        <circle cx="20" cy="15" r="9" fill={figure.color} />
        <line x1="11" y1="12" x2="29" y2="12" stroke="white" strokeWidth="2" />
        <line x1="11" y1="18" x2="29" y2="18" stroke="white" strokeWidth="2" />
        <ellipse cx="20" cy="48" rx="11" ry="27" fill={figure.color} />
        <line x1="9" y1="30" x2="31" y2="30" stroke="white" strokeWidth="2.5" />
        <line x1="9" y1="38" x2="31" y2="38" stroke="white" strokeWidth="2.5" />
        <line x1="9" y1="46" x2="31" y2="46" stroke="white" strokeWidth="2.5" />
        <line x1="9" y1="54" x2="31" y2="54" stroke="white" strokeWidth="2.5" />
        <line x1="9" y1="62" x2="31" y2="62" stroke="white" strokeWidth="2.5" />
        <circle cx="17" cy="14" r="1.5" fill="white" />
        <circle cx="23" cy="14" r="1.5" fill="white" />
      </svg>
    );
  }
  if (figure.type === 'tall') {
    return (
      <svg viewBox="0 0 30 80" className={className}>
        <rect x="5" y="10" width="20" height="60" rx="10" fill={figure.color} />
        <circle cx="12" cy="25" r="2" fill="white" />
        <circle cx="18" cy="25" r="2" fill="white" />
      </svg>
    );
  }
  if (figure.type === 'ball') {
    return (
      <svg viewBox="0 0 50 50" className={className}>
        <defs>
          <radialGradient id={`shine-${figure.color.replace('#', '')}`}>
            <stop offset="0%" stopColor="white" />
            <stop offset="100%" stopColor="transparent" />
          </radialGradient>
        </defs>
        <circle cx="25" cy="25" r="20" fill={figure.color} />
        <ellipse cx="25" cy="25" rx="20" ry="20" fill={`url(#shine-${figure.color.replace('#', '')})`} opacity="0.3" />
      </svg>
    );
  }
  // default: person
  return (
    <svg viewBox="0 0 40 80" className={className}>
      <circle cx="20" cy="15" r="8" fill={figure.color} />
      <ellipse cx="20" cy="45" rx="10" ry="25" fill={figure.color} />
      <circle cx="17" cy="14" r="1.5" fill="white" />
      <circle cx="23" cy="14" r="1.5" fill="white" />
    </svg>
  );
};
